import React from 'react';

export default function FitnessHubsOnlyToggle({ checked, onChange, disabled = false }) {
	return (
		<button
			type="button"
			role="switch"
			aria-checked={checked}
			disabled={disabled}
			onClick={() => !disabled && onChange(!checked)}
			className={`group w-full rounded-2xl border p-4 text-left transition focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:cursor-not-allowed disabled:opacity-70 ${
				checked
					? 'border-yellow-300 bg-gradient-to-br from-yellow-50 via-white to-yellow-100 shadow-sm dark:border-yellow-600 dark:from-dark-card dark:via-dark-card dark:to-dark-card'
					: 'border-gray-200 bg-gray-50 hover:border-gray-300 hover:bg-white dark:border-dark-border dark:bg-dark-card dark:hover:border-gray-500 dark:hover:bg-dark-bg'
			}`}
		>
			<div className="flex items-start gap-3">
				<span
					className={`mt-0.5 flex h-10 w-10 shrink-0 items-center justify-center rounded-xl transition ${
						checked
							? 'bg-yellow-500 text-white shadow-md'
							: 'bg-white text-gray-400 border border-gray-200 dark:bg-dark-bg dark:text-dark-text-secondary dark:border-dark-border'
					}`}
					aria-hidden="true"
				>
					<i className="fa-solid fa-heart-pulse text-sm" />
				</span>
				<span className="min-w-0 flex-1">
					<span className="flex items-center gap-2">
						<span className="text-sm font-semibold text-gray-900 dark:text-dark-text">
							Fitness-focused hubs
						</span>
						{checked ? (
							<span className="rounded-full border border-yellow-200 bg-yellow-50 px-2 py-0.5 text-xs font-bold uppercase tracking-wider text-yellow-800 dark:border-yellow-600 dark:bg-dark-bg dark:text-yellow-300">
								Active
							</span>
						) : (
							<span className="rounded-full border border-gray-200 bg-white px-2 py-0.5 text-xs font-bold uppercase tracking-wider text-gray-500 dark:border-dark-border dark:bg-dark-bg dark:text-dark-text-secondary">
								All hubs
							</span>
						)}
					</span>
					<span className="mt-1 block text-xs leading-relaxed text-gray-600 dark:text-dark-text-secondary">
						{checked
							? 'Showing Fitness Hub and Nutrition Lab only. Fantasy football hubs, Explore, Dashboard, and My Rosters are hidden.'
							: 'All hubs are visible, including Best Ball Zone, The Classroom, and Front Office.'}
					</span>
				</span>
				<span
					className={`relative mt-1 h-6 w-11 shrink-0 rounded-full transition ${
						checked ? 'bg-yellow-500' : 'bg-gray-300 dark:bg-gray-600'
					}`}
					aria-hidden="true"
				>
					<span
						className={`absolute top-0.5 left-0.5 h-5 w-5 rounded-full bg-white shadow transition transform ${
							checked ? 'translate-x-full' : 'translate-x-0'
						}`}
					/>
				</span>
			</div>
		</button>
	);
}
